module.exports = __webpack_public_path__ + "static/media/analysis.7501735b.svg";